import { all } from 'redux-saga/effects';
import AccountSagas from './account';
import SessionSagas from './session';
import TemplateTagListSagas from './templateTagList';
import UploadSagas from './upload';
import UserFilesSaga from './userFiles';
import SecuritySagas from './security';
import SuppressionsSagas from './suppressions';
import StatisticsSagas from './statistics';
import LogsSagas from './logs';
import ChannelsSagas from './channels';
import PoolsSagas from './pools';
import ReportsSagas from './reports';
import InboundSagas from './inbound';
import WebhooksSagas from './webhooks';
import EmailsSagas from './emails';
import LocationSagas from './location';
import ExportsSagas from './exports';
import ProductSagas from './product';
import CampaignsSagas from './campaigns';
import AuthSagas from './auth';
import NotificationSagas from './notification';
import DeviceDetailsSagas from './deviceDetails';
import singleLeadsVerificationSagas from 'evsApp/singleLeads/sagas';
import fileVerificationSagas from 'evsApp/verificationFiles/sagas';
import MarketingSagas from 'marketingApp/sagas';
import PaymentsSagas from './payments';
export default function* rootSaga(): any {
    yield all([
        ...AccountSagas,
        ...ChannelsSagas,
        ...SessionSagas,
        ...TemplateTagListSagas,
        ...UploadSagas,
        ...UserFilesSaga,
        ...SecuritySagas,
        ...SuppressionsSagas,
        ...StatisticsSagas,
        ...LogsSagas,
        ...PoolsSagas,
        ...InboundSagas,
        ...WebhooksSagas,
        ...EmailsSagas,
        ...LocationSagas,
        ...ExportsSagas,
        ...ProductSagas,
        ...ReportsSagas,
        ...CampaignsSagas,
        ...AuthSagas,
        ...NotificationSagas,
        ...DeviceDetailsSagas,
        ...PaymentsSagas,
        ...singleLeadsVerificationSagas,
        ...fileVerificationSagas,
        ...MarketingSagas, // emailmarketing-dashboard/nextGenDash/src/exposes/sagas.ts
    ]);
}
